import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type ClientStoreClient
 */
const initialState = {
  clientList: { loading: false, data: null, error: null },
  clientAgreementList: { loading: false, data: null, error: null },
  clientTdsList: { loading: false, data: null, error: null },
  clientFilterList: { loading: false, data: null, error: null },
  createClient: { loading: false, data: null, error: null },
  updateClient: { loading: false, data: null, error: null },
  deleteClient: { loading: false, data: null, error: null },
  uploadClient: { loading: false, data: null, error: null },
  deleteAllClient: { loading: false, data: null, error: null },
};

export const ClientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    fetchClientListRequest: (client, action) => {
      client.clientList.loading = true;
      client.clientList.error = null;
    },
    fetchTdsListRequest: (client, action) => {
      client.clientTdsList.loading = true;

      client.clientTdsList.error = null;
    },
    fetchClientListSuccess: (client, action) => {
      client.clientList.data = action.payload;
      client.clientList.loading = false;
      client.clientList.error = null;
    },
    fetchTdsListSuccess: (client, action) => {
      client.clientTdsList.data = action.payload;

      client.clientTdsList.loading = false;

      client.clientTdsList.error = null;
    },
    fetchTdsListFailure: (client, action) => {
      client.clientTdsList.data = null;

      client.clientTdsList.loading = false;

      client.clientTdsList.error = action.payload;
    },
    fetchClientListFailure: (client, action) => {
      client.clientList.data = null;
      client.clientList.loading = false;
      client.clientList.error = action.payload;
    },
    fetchClientFilterListRequest: (client, action) => {
      client.clientFilterList.loading = true;
      client.clientFilterList.error = null;
    },
    fetchClientFilterListSuccess: (client, action) => {
      client.clientFilterList.data = action.payload;
      client.clientFilterList.loading = false;
      client.clientFilterList.error = null;
    },
    fetchClientFilterListFailure: (client, action) => {
      client.clientFilterList.data = null;
      client.clientFilterList.loading = false;
      client.clientFilterList.error = action.payload;
    },
    createClientRequest: (client, action) => {
      client.createClient.loading = true;
      client.createClient.error = null;
    },
    createClientSuccess: (client, action) => {
      client.createClient.data = action.payload;
      client.createClient.loading = false;
      client.createClient.error = null;
      client.clientList = addNewclientSuccess(action.payload, {
        ...client.clientList,
      });
    },
    createClientFailure: (client, action) => {
      client.createClient.data = null;
      client.createClient.loading = false;
      client.createClient.error = action.payload;
    },
    updateClientRequest: (client, action) => {
      client.updateClient.loading = true;
      client.updateClient.error = null;
    },
    deleteClientRequest: (client, action) => {
      client.deleteClient.loading = true;
      client.deleteClient.error = null;
    },

    uploadClientRequest: (client, action) => {
      client.uploadClient.loading = true;
      client.uploadClient.error = null;
    },




    uploadClientSuccess: (client, action) => {

      client.uploadClient.data = action.payload;

      client.uploadClient.loading = false;

      client.uploadClient.error = null;

      // client.clientTdsList = deleteClientListSuccess(action.payload, {

      //   ...client.clientTdsList,

      // });

    },

    deleteAllClientRequest: (client, action) => {
      client.deleteAllClient.loading = true;
      client.deleteAllClient.error = null;
    },

    updateClientSuccess: (client, action) => {
      client.updateClient.data = action.payload;
      client.updateClient.loading = false;
      client.updateClient.error = null;
      client.clientList = updateClientListSuccess(action.payload, {
        ...client.clientList,
      });
    },

    deleteClientSuccess: (client, action) => {
      client.deleteClient.data = action.payload;
      client.deleteClient.loading = false;
      client.deleteClient.error = null;
      client.clientTdsList = deleteClientListSuccess(action.payload, {
        ...client.clientTdsList,
      });
    },



    deleteAllClientSuccess: (client, action) => {
      client.deleteAllClient.data = action.payload;
      client.deleteAllClient.loading = false;
      client.deleteAllClient.error = null;
      client.clientTdsList = deleteAllClientListSuccess(action.payload, {
        ...client.clientTdsList,
      });
    },


    updateClientFaliure: (client, action) => {
      client.updateClient.data = null;
      client.updateClient.loading = false;
      client.updateClient.error = action.payload;
    },
    deleteClientFaliure: (client, action) => {
      client.deleteClient.data = null;
      client.deleteClient.loading = false;
      client.deleteClient.error = action.payload;
    },
    deleteAllClientFaliure: (client, action) => {
      client.deleteAllAllClient.data = null;
      client.deleteAllClient.loading = false;
      client.deleteAllClient.error = action.payload;
    },
    fetchClientAgreementListRequest: (client, action) => {
      client.clientAgreementList.loading = true;
      client.clientAgreementList.error = null;
    },
    
    fetchClientAgreementListSuccess: (client, action) => {
      client.clientAgreementList.data = action.payload;
      client.clientAgreementList.loading = false;
      client.clientAgreementList.error = null;
    },
    fetchClientAgreementListFailure: (client, action) => {
      client.clientAgreementList.data = null;
      client.clientAgreementList.loading = false;
      client.clientAgreementList.error = action.payload;
    },
  },
});
function addNewclientSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}
function updateClientListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}

function deleteClientListSuccess(dataToUpdate1, state) {
  state.data.data = state.data.data.map((lead1) => {
    if (lead1.accId !== dataToUpdate1._id) return lead1;
    return { ...lead1, ...dataToUpdate1 };
  });
  return state;
}


function deleteAllClientListSuccess(dataToUpdate2, state) {
  state.data.data = state.data.data.map((lead2) => {
    if (lead2.accId !== dataToUpdate2._id) return lead2;
    return { ...lead2, ...dataToUpdate2 };
  });
  return state;
}


export const {
  fetchClientListRequest,
  fetchClientListSuccess,
  fetchClientListFailure,
  fetchClientFilterListRequest,
  fetchClientFilterListSuccess,
  fetchClientFilterListFailure,
  createClientRequest,
  createClientSuccess,
  createClientFailure,
  updateClientRequest,
  updateClientSuccess,
  updateClientFaliure,
  deleteClientRequest,
  uploadClientRequest,
  uploadClientFaliure,

  deleteAllClientRequest,
  deleteAllClientSuccess,
  deleteAllClientFaliure,
  deleteClientSuccess,
  uploadClientSuccess,

  deleteClientFaliure,
  fetchTdsListRequest,

  fetchTdsListSuccess,
  fetchTdsListFailure,

  fetchClientAgreementListRequest,
  fetchClientAgreementListSuccess,
  fetchClientAgreementListFailure,
} = ClientSlice.actions;

/**
 *
 * @param {*} store
 * @returns {ClientStoreClient['clientList']}
 */
export const getClientListState = (store) => store.client?.clientList;
export const getTdsListState = (store) => store.client?.clientTdsList;
export const getClientFilterListState = (store) =>
  store.client?.clientFilterList;
export const getClientCreateState = (store) => store.client?.createClient;
export const getClientUpdateState = (store) => store.client?.updateClient;
export const getClientDeleteState = (store) => store.client?.deleteClient;
export const getClientUploadSuccess = (store)=> store.client?.uploadClient;
export const getClientAllDeleteState = (store) => store.client?.deleteAllClient;
export const getClientAgreementListState = (store) => store.client?.clientAgreementList;
export default ClientSlice.reducer;
